(function() {
  var path = window.location.pathname;
  var productSlug = '/products/1-2-permanent-fluorescent-green-calibration-dots';

  // ============================================================
  // Suppress Klaviyo popup flyout on hospitals page
  // ============================================================
  if (path === '/pages/hospitals' || path === productSlug) {
    var ks = document.createElement('style');
    ks.textContent = 'div.kl-private-reset-css-Xuajs1[style*="z-index: 90000"], div.kl-private-reset-css-Xuajs1[style*="position: fixed"] { display: none !important; }';
    document.head.appendChild(ks);
  }

  // ============================================================
  // Shared: Inject styles once
  // ============================================================
  if (path === '/pages/hospitals' || path === '/pages/need-to-use-a-purchase-order' || path === productSlug) {
    var style = document.createElement('style');
    style.textContent =
      /* Getting Started section */
      '#cl-getting-started { padding: 60px 24px; margin: 0; }' +
      '#cl-getting-started .cl-gs-inner { max-width: 920px; margin: 0 auto; }' +
      '#cl-getting-started .cl-gs-heading { font-family: Arvo, serif; font-size: 32px; font-weight: 700; color: #333; text-align: center; margin: 0 0 6px; line-height: 1.2; }' +
      '#cl-getting-started .cl-gs-subhead { font-family: Inter, Questrial, "Helvetica Neue", Arial, sans-serif; font-size: 15px; color: #888; text-align: center; margin: 0 0 36px; line-height: 1.5; }' +
      '#cl-getting-started .cl-gs-cards { display: flex; gap: 20px; justify-content: center; align-items: stretch; }' +
      '#cl-getting-started .cl-gs-card { flex: 1; max-width: 420px; background: #fff; border-radius: 8px; padding: 32px 28px 28px; position: relative; box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 4px 12px rgba(0,0,0,0.04); transition: box-shadow 0.2s ease; }' +
      '#cl-getting-started .cl-gs-card:hover { box-shadow: 0 2px 6px rgba(0,0,0,0.1), 0 8px 24px rgba(0,0,0,0.06); }' +
      '#cl-getting-started .cl-gs-card--primary { border: 2px solid #2a7d4f; }' +
      '#cl-getting-started .cl-gs-card--secondary { border: 1px solid #e0e0e0; }' +
      '#cl-getting-started .cl-gs-badge { position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #2a7d4f; color: #fff; font-family: Inter, Questrial, "Helvetica Neue", Arial, sans-serif; font-size: 11px; font-weight: 600; padding: 4px 16px; border-radius: 100px; letter-spacing: 0.8px; text-transform: uppercase; white-space: nowrap; }' +
      '#cl-getting-started .cl-gs-card-title { font-family: Arvo, serif; font-size: 20px; font-weight: 700; text-align: center; margin: 0 0 20px; line-height: 1.3; }' +
      '#cl-getting-started .cl-gs-card--primary .cl-gs-card-title { color: #2a7d4f; }' +
      '#cl-getting-started .cl-gs-card--secondary .cl-gs-card-title { color: #555; }' +
      '#cl-getting-started .cl-gs-list { list-style: none; padding: 0; margin: 0; }' +
      '#cl-getting-started .cl-gs-list li { padding: 10px 0; border-bottom: 1px solid #f2f2f2; font-family: Inter, Questrial, "Helvetica Neue", Arial, sans-serif; font-size: 15px; color: #333; line-height: 1.5; display: flex; align-items: baseline; gap: 10px; }' +
      '#cl-getting-started .cl-gs-list li:last-child { border-bottom: none; }' +
      '#cl-getting-started .cl-gs-list li strong { font-weight: 600; }' +
      '#cl-getting-started .cl-gs-icon { flex-shrink: 0; width: 18px; height: 18px; display: inline-flex; align-items: center; justify-content: center; border-radius: 50%; font-size: 11px; font-weight: 700; line-height: 1; }' +
      '#cl-getting-started .cl-gs-icon--check { background: #e8f5ee; color: #2a7d4f; }' +
      '#cl-getting-started .cl-gs-icon--bullet { background: #f5f5f5; color: #888; font-size: 8px; }' +
      '#cl-getting-started .cl-gs-rec { font-family: Inter, Questrial, "Helvetica Neue", Arial, sans-serif; font-size: 14px; color: #666; text-align: center; max-width: 680px; margin: 28px auto 0; line-height: 1.65; }' +
      '#cl-getting-started .cl-gs-rec strong { color: #333; font-weight: 600; }' +
      '@media (max-width: 680px) {' +
        '#cl-getting-started { padding: 40px 16px; }' +
        '#cl-getting-started .cl-gs-heading { font-size: 24px; }' +
        '#cl-getting-started .cl-gs-subhead { font-size: 14px; margin-bottom: 28px; }' +
        '#cl-getting-started .cl-gs-cards { flex-direction: column; align-items: center; gap: 24px; }' +
        '#cl-getting-started .cl-gs-card { max-width: 100%; width: 100%; padding: 28px 20px 24px; }' +
        '#cl-getting-started .cl-gs-card-title { font-size: 18px; }' +
        '#cl-getting-started .cl-gs-list li { font-size: 14px; padding: 9px 0; }' +
        '#cl-getting-started .cl-gs-rec { font-size: 13px; margin-top: 20px; }' +
      '}' +

      /* PO page callout */
      '#cl-po-callout { max-width: 800px; margin: 10px auto 30px; padding: 20px 28px; background: #f5faf7; border-left: 4px solid #2a7d4f; border-radius: 0 6px 6px 0; font-family: Inter, Questrial, "Helvetica Neue", Arial, sans-serif; font-size: 15px; color: #444; line-height: 1.65; }' +
      '#cl-po-callout strong { color: #2a7d4f; font-weight: 600; }' +
      '@media (max-width: 680px) {' +
        '#cl-po-callout { margin: 10px 16px 24px; padding: 16px 18px; font-size: 14px; }' +
      '}' +

      /* Product page callout */
      '.cl-prod-info { padding: 14px 18px; background: #f5faf7; border: 1px solid #d4e8dc; border-radius: 6px; font-family: Inter, Questrial, "Helvetica Neue", Arial, sans-serif; font-size: 13px; color: #444; line-height: 1.55; }' +
      '.cl-prod-info .cl-po-title { font-family: Arvo, serif; font-size: 14px; font-weight: 700; color: #2a7d4f; margin: 0 0 6px; display: flex; align-items: center; gap: 6px; }' +
      '.cl-prod-info .cl-po-title svg { flex-shrink: 0; }' +
      '.cl-prod-info .cl-po-rows { display: flex; flex-direction: column; gap: 4px; }' +
      '.cl-prod-info .cl-po-row { display: flex; justify-content: space-between; align-items: baseline; }' +
      '.cl-prod-info .cl-po-row span:first-child { color: #666; }' +
      '.cl-prod-info .cl-po-row span:last-child { font-weight: 600; color: #333; }' +
      '.cl-prod-info .cl-po-divider { border: none; border-top: 1px solid #e4ede7; margin: 8px 0; }' +
      '.cl-prod-info .cl-po-note { font-size: 12px; color: #777; margin: 0; line-height: 1.5; }' +
      '.cl-prod-info .cl-po-note strong { color: #555; }' +
      '@media (max-width: 680px) {' +
        '.cl-prod-info { padding: 12px 14px; font-size: 12px; }' +
        '.cl-prod-info .cl-po-title { font-size: 13px; }' +
        '.cl-prod-info .cl-po-note { font-size: 11px; }' +
      '}';
    document.head.appendChild(style);
  }

  // ============================================================
  // HOSPITALS PAGE - "Getting Started" section
  // ============================================================
  if (path === '/pages/hospitals') {
    var startTime = Date.now();

    function insertGettingStarted() {
      if (document.getElementById('cl-getting-started')) return;

      var targetRow = document.getElementById('r-1691694640537');
      if (!targetRow) {
        var h2s = document.querySelectorAll('h2');
        for (var i = 0; i < h2s.length; i++) {
          if (h2s[i].textContent.indexOf('Save Time') >= 0) {
            var el = h2s[i];
            while (el && el.parentElement) {
              el = el.parentElement;
              if (el.classList && el.classList.contains('gf_row-fluid')) { targetRow = el; break; }
            }
            break;
          }
        }
      }

      if (!targetRow) {
        if (Date.now() - startTime < 5000) setTimeout(insertGettingStarted, 200);
        return;
      }

      var section = document.createElement('div');
      section.id = 'cl-getting-started';
      section.innerHTML =
        '<div class="cl-gs-inner">' +
          '<h2 class="cl-gs-heading">Getting Started Is Easy</h2>' +
          '<p class="cl-gs-subhead">Choose the ordering method that works best for your facility</p>' +
          '<div class="cl-gs-cards">' +
            '<div class="cl-gs-card cl-gs-card--primary">' +
              '<div class="cl-gs-badge">Recommended</div>' +
              '<div class="cl-gs-card-title">Purchase Card</div>' +
              '<ul class="cl-gs-list">' +
                '<li><span class="cl-gs-icon cl-gs-icon--check">\u2713</span>No minimum \u2014 buy just <strong>1 pack</strong></li>' +
                '<li><span class="cl-gs-icon cl-gs-icon--check">\u2713</span><strong>Usually ships within 1 business day</strong></li>' +
                '<li><span class="cl-gs-icon cl-gs-icon--check">\u2713</span>Skip the vendor setup process</li>' +
                '<li><span class="cl-gs-icon cl-gs-icon--check">\u2713</span>Evaluate the product immediately</li>' +
              '</ul>' +
            '</div>' +
            '<div class="cl-gs-card cl-gs-card--secondary">' +
              '<div class="cl-gs-card-title">Purchase Order / Net Terms</div>' +
              '<ul class="cl-gs-list">' +
                '<li><span class="cl-gs-icon cl-gs-icon--bullet">\u2022</span>$200 minimum (~10 packs)</li>' +
                '<li><span class="cl-gs-icon cl-gs-icon--bullet">\u2022</span>Net 30 terms available</li>' +
                '<li><span class="cl-gs-icon cl-gs-icon--bullet">\u2022</span>Requires vendor setup (timeline varies)</li>' +
                '<li><span class="cl-gs-icon cl-gs-icon--bullet">\u2022</span>Dedicated account manager</li>' +
              '</ul>' +
            '</div>' +
          '</div>' +
          '<p class="cl-gs-rec"><strong>Our recommendation:</strong> Use your purchase card to order a single pack first. We\u2019ll ship it same day so your team can evaluate the product immediately\u2014while your procurement team works on getting us into your vendor system at their own pace.</p>' +
        '</div>';

      targetRow.parentNode.insertBefore(section, targetRow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', insertGettingStarted);
    } else {
      insertGettingStarted();
    }
  }

  // ============================================================
  // PURCHASE ORDERS PAGE - Purchase card callout - updated to be in Online Store Editor: https://admin.shopify.com/store/chromalabel-com/themes/185107906850/editor 
  // ============================================================
  /* if (path === '/pages/need-to-use-a-purchase-order') {
    var poStartTime = Date.now();

    function insertPOCallout() {
      if (document.getElementById('cl-po-callout')) return;

      var paras = document.querySelectorAll('main p');
      var targetPara = null;
      for (var i = 0; i < paras.length; i++) {
        var t = paras[i].textContent;
        if (t.indexOf('$200 order minimum') >= 0 || t.indexOf('same business day') >= 0) {
          targetPara = paras[i];
          break;
        }
      }

      if (!targetPara) {
        if (Date.now() - poStartTime < 5000) setTimeout(insertPOCallout, 200);
        return;
      }

      var section = targetPara.closest('.container') || targetPara.closest('section') || targetPara.closest('[class*="section"]');
      if (!section) {
        var bl = targetPara.closest('div.block-list');
        if (bl) section = bl.parentElement.parentElement.parentElement;
      }
      if (!section) return;

      var callout = document.createElement('div');
      callout.id = 'cl-po-callout';
      callout.innerHTML = '<strong>Want to try us out first?</strong> Use a purchase card directly on our website\u2014no minimum order required, and we ship same day. It\u2019s the fastest way to get product in hand while your team handles vendor setup.';

      section.parentNode.insertBefore(callout, section.nextSibling);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', insertPOCallout);
    } else {
      insertPOCallout();
    }
  }
    */

  // ============================================================
  // HOSPITALS FAQ - Update PO answer
  // ============================================================
  if (path === '/pages/hospitals') {
    function updateFAQ() {
      var articles = document.querySelectorAll('article');
      for (var i = 0; i < articles.length; i++) {
        var text = articles[i].textContent;
        if (text.indexOf('Purchase Orders') >= 0 && text.indexOf('$200 minimum') < 0 && text.indexOf('just a few questions') >= 0) {
          var textBlock = articles[i].querySelector('.elm.text-edit');
          if (textBlock) {
            textBlock.innerHTML = 'Yes, we accept Purchase Orders! There\u2019s a $200 minimum for PO/invoice orders (about 10 packs), and we offer Net 30 terms. <strong>Want to try us first?</strong> Use a purchase card directly on our website\u2014no minimum, and we\u2019ll ship even a single pack the same day. This lets your team evaluate the product right away while your procurement department handles vendor setup at their own pace. More info on our <a href="https://www.chromalabel.com/pages/need-to-use-a-purchase-order">Purchase Order page</a>, or just send us a note: info@chromalabel.com';
          }
          break;
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(updateFAQ, 500); });
    } else {
      setTimeout(updateFAQ, 500);
    }
  }

  // ============================================================
  // PRODUCT PAGE - Ordering info below Add To Cart - Updated to be in GemPages: https://app.gempages.net/editor?id=1736442469 
  // ============================================================
  /* if (path === productSlug) {
    var prodStartTime = Date.now();

    function insertProductCallout() {
      // Don't insert twice
      if (document.querySelector('.cl-prod-info')) return;

      // Find ALL Add To Cart buttons (desktop + mobile have separate ones)
      var btns = document.querySelectorAll('button');
      var addToCartBtns = [];
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].textContent.trim().indexOf('Add To Cart') >= 0) {
          addToCartBtns.push(btns[i]);
        }
      }

      if (addToCartBtns.length === 0) {
        if (Date.now() - prodStartTime < 5000) setTimeout(insertProductCallout, 200);
        return;
      }

      var calloutHTML =
        '<div class="cl-po-title">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="#2a7d4f" stroke-width="1.5"/><path d="M5 8.5L7 10.5L11 6" stroke="#2a7d4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          'Ordering for Your Facility' +
        '</div>' +
        '<div class="cl-po-rows">' +
          '<div class="cl-po-row"><span>Purchase card</span><span>No minimum \u2014 ships same day</span></div>' +
          '<div class="cl-po-row"><span>PO / Net terms</span><span>$200 min (~10 packs)</span></div>' +
        '</div>' +
        '<hr class="cl-po-divider">' +
        '<p class="cl-po-note"><strong>Tip:</strong> Order a single pack with your purchase card to evaluate immediately\u2014skip the vendor setup wait.</p>';

      for (var j = 0; j < addToCartBtns.length; j++) {
        var container = addToCartBtns[j].closest('.module-wrap') || addToCartBtns[j].parentElement;
        var callout = document.createElement('div');
        callout.className = 'cl-prod-info';
        callout.style.marginTop = '16px';
        callout.innerHTML = calloutHTML;
        container.parentNode.insertBefore(callout, container.nextSibling);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', insertProductCallout);
    } else {
      insertProductCallout();
    }
  } */
})();
